/**
 * The horizontal scale factor an ancestor `transform: scale()` (or the
 * element's own) has applied to `element` on screen.
 *
 * Mouse events report screen pixels, while layout code works in the element's
 * untransformed CSS pixels. Dividing a screen-space distance by this factor
 * converts it back to layout pixels. `offsetWidth` ignores transforms while
 * `getBoundingClientRect()` includes them, so their ratio is the applied scale.
 *
 * Measure a wide element when precision matters: `offsetWidth` is rounded to
 * whole pixels, so the ratio gets noisier the narrower the element is.
 */
export var getRenderedScale = function (element) {
    if (!element)
        return 1;
    var layoutWidth = element.offsetWidth;
    if (!layoutWidth)
        return 1;
    var renderedWidth = element.getBoundingClientRect().width;
    if (!renderedWidth)
        return 1;
    return renderedWidth / layoutWidth;
};
/**
 * The window `element` is shown in. Usually the main window, but content can
 * be popped out into another one (see PopoutWindow), and listeners for drags,
 * outside clicks and animation frames must be registered on that window.
 */
export var getOwnerWindow = function (element) { var _a; return (_a = element === null || element === void 0 ? void 0 : element.ownerDocument.defaultView) !== null && _a !== void 0 ? _a : window; };
